import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, ComponentRef, EmbeddedViewRef, OnDestroy } from '@angular/core';

export class NativeComponentRef<T> {
    nativeElement: HTMLElement;
    _ref: ComponentRef<T>;
}

@Injectable()
export class DynamicComponentService implements OnDestroy {
    protected _containerElements: Map<string, NativeComponentRef<any>> = new Map();

    constructor(
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _appRef: ApplicationRef,
        private _injector: Injector
    ) {}

    ngOnDestroy() {
        this._containerElements.forEach((value, key) => this.removeContainerElement(key));
    }

    public get<T>(uniqueID: string): NativeComponentRef<T> {
        return this._containerElements.get(uniqueID);
    }

    public createContainer<T>(uniqueID: string, component: any): NativeComponentRef<T> {
        // Create a component reference from the component
        const componentRef = this._componentFactoryResolver.resolveComponentFactory<T>(component).create(this._injector);

        // Attach component to the appRef so that it's inside the ng component tree
        this._appRef.attachView(componentRef.hostView);

        // Get DOM element from component
        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        domElem.id = uniqueID;

        const _nativeComponentRef = { nativeElement: domElem, _ref: componentRef };
        this._containerElements.set(uniqueID, _nativeComponentRef);

        // Append DOM element to the body
        document.body.appendChild(domElem);
        return _nativeComponentRef;
    }

    public removeContainerElement(uniqueID: string): void {
        const _element = this._containerElements.get(uniqueID);
        if (_element) {
            this._appRef.detachView(_element._ref.hostView);
            _element._ref.destroy();
            this._containerElements.delete(uniqueID);
        }
    }
}
